import { InputIconWrapper, NumberInput } from '@library/components/inputs';
import { useCallback, useState } from 'react';
import { NUMBER_INPUT_DEFAULT_CLASSES } from '@library/components/inputs/NumberInput';
import type { TransactionMaxValues } from '@library/types/permissions';
import { useDebounceFn } from '@library/hooks/useDebounce';

export interface UserRoleTransactionMaxProps {
  transactionMaxes: Array<TransactionMaxValues>;
  onTransactionMaxChange: (
    transactionMaxes: Array<TransactionMaxValues>
  ) => void;
}

export const UserRoleTransactionMax = ({
  transactionMaxes,
  onTransactionMaxChange
}: UserRoleTransactionMaxProps) => {
  const [transactionMaxValues, setTransactionMaxValues] =
    useState<Array<TransactionMaxValues>>(transactionMaxes);

  const { debounce: debouncedOnTransactionMaxChange } = useDebounceFn(
    onTransactionMaxChange as (...args: unknown[]) => void,
    500
  );

  const handleTransactionMaxChange = useCallback(
    (value: string, index: number) => {
      setTransactionMaxValues((prevValues) => {
        const updatedValues = prevValues.map((transactionMax, i) =>
          i === index ? { ...transactionMax, value } : transactionMax
        );
        debouncedOnTransactionMaxChange(updatedValues);
        return updatedValues;
      });
    },
    [debouncedOnTransactionMaxChange]
  );

  return (
    <>
      <p className="text-soClean-140 flex rounded-md py-1 text-xs uppercase leading-6">
        Transaction Max
      </p>
      <div className="bg-soFresh-120 border-soFresh-140 relative flex flex-col gap-y-2 rounded-md border border-solid p-2">
        {transactionMaxValues.map(({ id, label, value }, index) => (
          <InputIconWrapper
            key={id}
            icon="$"
            className="flex flex-col gap-y-1"
            iconClassName="top-[35px]"
          >
            <NumberInput
              className={`${NUMBER_INPUT_DEFAULT_CLASSES} pl-10`}
              labelName={label}
              value={value}
              onValueChange={(inputValue) =>
                handleTransactionMaxChange(inputValue, index)
              }
            />
          </InputIconWrapper>
        ))}
      </div>
    </>
  );
};
